import { DataBean } from "../DataBean";

export class RawMaterialClose extends DataBean {


    public async createRawMaterialCloseForProductionOrder(idProductionOrder:any,productionOrderDate:any,idStoreDestinity:any,accountantDate:any,description:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_createRawMaterialCloseForProductionOrder_Number_java.util.Date_Number_java.util.Date_String_Number", [idProductionOrder,productionOrderDate,idStoreDestinity,accountantDate,description,idEmployee]);
    }

}